import React, { useEffect, useState } from "react";
import {
  ContactInfo,
  JourneyInfo,
  LoginInfo,
  StepsInfo,
} from "./Utils/IvfLabelInput";
// import { RiErrorWarningLine } from "react-icons/ri";
// import Subscription from "./Subscription";
import Button from "@mui/material/Button";
// import { useGetSubscriptionsQuery } from "../../../Service/subscription";
// import {
//   useAddHospitalMutation,
//   useAddMerchantSubscriptionMutation,
//   useGetTransactionHistoryQuery,
//   useUpdateHospitalMutation,
// } from "../../../Service/hospitals";
import {
  validate,
  validateEmail,
  validatePassword,
  validatePhone,
} from "../../../utils";
import Toast from "../../../Component/DigitalMarketing/Toast";
import ImageSelectors from "../../../Component/DigitalMarketing/ImageSelectors";
import PermissionCheck from "../../../Component/PermissionCheck";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import DynamicPTags from "./DynamicTags";
import {
  useAddIVFJourneyMutation,
  useDeleteIVFJourneystepMutation,
  useUpdateIVFJourneyMutation,
} from "../../../Service/ivfJourneyStage";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import { event } from "react-ga";
import { useSelector } from "react-redux";

function StageDetails(props) {
  const { stepdeleted, setStepdeleted, branchOptions } = props;
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;
  const [journey, setJourney] = useState(props.journey);
  const [stepdeletedId, setStepdeletedId] = useState("");
  const [updated, setUpdated] = useState(props.updated);
  const [created, setCreated] = useState(props.created);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [submit, setSubmit] = useState(false);
  const [addJourney, { isLoading: addLoading }] = useAddIVFJourneyMutation();
  const [updateJourney, { isLoading: updateLoading }] =
    useUpdateIVFJourneyMutation();
  const { open, message, openSnackBar, type } = useSnackbar();
  useEffect(() => {
    setJourney(props.journey);
    setUpdated(props.updated);
    setCreated(props.created);
    setStepdeleted(props.stepdeleted);

    // console.log(props.journey);
    // console.log(props.stepdeleted);
  }, [props]);
  const handleChangeInfo = (
    id: any,
    event: { target: { name: any; value: any; checked: any } }
  ) => {
    setSubmit(false);
    const { name, value, checked } = event.target;

    setJourney((prev) => {
      let updatedJourney = { ...prev };

      // If steps is empty, initialize it as an array
      if (!updatedJourney.steps) {
        updatedJourney.steps = [];
      }

      if (name === "stepName" || (name === "description" && id !== undefined)) {
        // Check if the step with the matching id exists
        const existingStepIndex = updatedJourney.steps.findIndex(
          (step) => step.id === id
        );

        // console.log("steps",existingStepIndex);
        // console.log("steps", updatedJourney.steps.length);

        if (existingStepIndex !== -1) {
          // Update the existing step
          const updatedSteps = [...updatedJourney.steps]; // Create a copy of the existing steps array
          updatedSteps[existingStepIndex] = {
            ...updatedSteps[existingStepIndex],
            [name]: value, // Update the specified property with the new value
          };
          updatedJourney.steps = updatedSteps; // Update the steps array in the state with the updated array
        }
        // else if (updatedJourney.steps.length===0){
        //   const newStep = { id: updatedJourney.steps.length+1, [name]: value }; // Create a new step object
        //   updatedJourney.steps = [...updatedJourney.steps, newStep];
        // }
        else {
          // Add a new step
          const newStep = {
            id: updatedJourney.steps.length - 30,
            [name]: value,
          }; // Create a new step object
          updatedJourney.steps = [...updatedJourney.steps, newStep]; // Add the new step to the steps array in the state
        }
      } else if (name === "journeyStageName" || name === "description") {
        // Update journeyStageName or description
        updatedJourney[name] = value;
      } else if (name === "ivf_journey_status") {
        // Update ivf_journey_status
        updatedJourney[name] = checked ? 1 : 0;
      } else {
        // Update other properties
        updatedJourney[name] = value;
      }

      return updatedJourney;
    });
  };

  // function openSnackBarerror(value) {
  //   openSnackBar(value, "error");
  // }
  // function isImageFile(value: any): boolean {
  //   return value instanceof File && value.type.startsWith("image/");
  // }
  function checkSteps(steps) {
    steps.every((step) => console.log(step));

    return steps.every((step) => step.stepName && step.description);
  }
  const onSave = async () => {
    setSubmit(true);
    const data = {
      id: journey.id || null,
      ...journey,
    };
    console.log(data);
    // branchId required only for admin
    const isBranchIdRequired = roleName === "admin";
    if (
      validate(journey.journeyStageName) &&
      validate(journey.description) &&
      (!isBranchIdRequired || journey?.branchId)
    ) {
      if (checkSteps(journey.steps)) {
        if (!journey.id) {
          if (validate(journey.journeyStageName)) {
            try {
              const newData = {
                ...data,
                steps: data.steps.map((step) => {
                  const { id, ...rest } = step;
                  return rest;
                }),
              };

              // console.log("addd",newData);
              const payload = await addJourney(newData).unwrap();
              // console.log("fulfilled", payload);

              props.setCreated(true);

              props.setshow(false);
              openSnackBar();
            } catch (error: any) {
              console.error("rejected", error?.data.message);
              openSnackBar(error?.data.message, "error");
            }
          }
        } else {
          // console.log(data);
          const updatedSteps = data.steps.map((step) => ({ ...step }));
          let previousId = journey?.steps[0]?.id; // Start with the id of the first step in the journey
          let conditionFailed = previousId < 0 ? true : false; // Flag to track if condition has failed
          // console.log("previousId",previousId);

          updatedSteps.forEach((step, index) => {
            // console.log("stepid",step.id);
            // console.log("previousId",previousId);

            // console.log("cont",( step.id && step.id < previousId));

            if (conditionFailed) {
              delete updatedSteps[index].id; // Remove id property for subsequent steps
            } else if (step.id && step.id < previousId) {
              delete updatedSteps[index].id; // Remove id property for the first step that fails the condition
              conditionFailed = true; // Set flag to true
            }
            previousId = step.id; // Update previousId for the next iteration
          });

          // console.log(updatedSteps);

          data.steps = updatedSteps;

          // console.log(data);

          updateJourney({
            id: journey.id,
            ...data,
          })
            .then((payload: any) => {
              if (payload?.error?.status === 400) {
                openSnackBar(payload?.error.data.message, "error");
              } else {
                props.setUpdated(true);
                props.setshow(false);
              }
            })
            .catch((err) => {
              // console.log("dsdsd", err);
              openSnackBar(err?.data.message, "error");
            });
        }
      } else {
        openSnackBar("Fill step details", "error");
      }
    } else {
      openSnackBar("Fill required data", "error");
    }
  };
  function Stepdeleted() {
    props.setStepdeleted(!stepdeleted);
  }
  useEffect(() => {
    // console.log(journey);
  }, [journey]);
  useEffect(() => {
    const updatedSteps = journey.steps.filter(
      (step) => step.id !== stepdeletedId
    );
    // console.log(updatedSteps);

    // Update the state with the modified 'steps' array
    setJourney((prevState) => ({
      ...prevState,
      steps: updatedSteps,
    }));
  }, [stepdeletedId]);

  return (
    <>
      <Toast open={open} type={type} message={message} />

      <li className="d-flex">
        <div>
          <h6
            style={{
              fontSize: "18px",
              fontWeight: "700",
              lineHeight: "22px",
              letterSpacing: 0,
              textAlign: "left",
            }}
          >
            {journey?.id ? "Edit Stage" : "Add Stage"}
          </h6>
          <p
            style={{
              fontSize: "18px",
              fontWeight: "500",
              lineHeight: "18px",
            }}
          >
            Treatment Journey
          </p>
        </div>
      </li>

      {JourneyInfo.map((a, i) => {
        if (a.role && a.role !== roleName) {
          return null;
        }
        if (a.name === "branchName" && roleName !== "branch") {
          return (
            <li className="input-custom" key={i}>
              <div className="d-flex justify-content-between mt-2">
                <div>
                  <label className="det-label">Branch Name</label>
                </div>
                <div>
                  <select
                    className="input-custom"
                    name="branchId"
                    value={journey?.branchId}
                    onChange={(event: any) => handleChangeInfo("", event)}
                    // disabled={view}
                  >
                    <option value="">Select Branch</option>
                    {branchOptions?.data?.map((branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.branchName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </li>
          );
        }
        return (
          <li
            className="input-custom"
            key={i}
            style={{ height: a.name == "description" ? "130px" : "" }}
          >
            <a.tag
              img={a.img}
              label={a.label}
              name={a.name}
              value={journey[a.key]}
              handleChange={handleChangeInfo}
              validation={a.validation}
              keyName={a.key}
              submit={submit}
            />
          </li>
        );
      })}
      <li className="d-flex">
        <div>
          <p
            style={{
              fontSize: "18px",
              fontWeight: "500",
              lineHeight: "18px",
            }}
          >
            Steps
          </p>
        </div>
      </li>

      <li>
        <DynamicPTags
          journey={journey}
          setJourney={props.setJourney}
          handleChangeInfo={handleChangeInfo}
          submit={submit}
          stepdeleted={stepdeleted}
          setStepdeleted={setStepdeleted}
          stepdeletedId={stepdeletedId}
          setStepdeletedId={setStepdeletedId}
        />
      </li>

      {/* { StepsInfo.map((a, i) => (
        
       
        <li className="input-custom" key={i} style={{height:a.name=="description"?"130px":""}}>
          <a.tag
            img={a.img}
            label={a.label}
            name={a.name}
            value={journey[a.key]}
            handleChange={handleChangeInfo}
            validation={a.validation}
            keyName={a.key}
            submit={submit}
          />
        </li>
     
    
  ))} */}
      {/* <Button onClick={handleAddChild} variant="contained" className="add-stage" style={{backgroundColor:"#F9F7FF",width: "125px",
height: "32px",margin:"0 0 40px 0",border:"1px solid #E6E6E6",boxShadow:"none",
color:"#000"}}  id="btn"><span style={{backgroundColor:"#6842D9",padding:"0 8px",borderRadius:"50%",color:"#fff"}} >+</span>&nbsp;&nbsp; Add Step</Button> */}

      {/* {PermissionCheck("ivf_journey_stages", "add") && !journey.id && ( */}
      <div className="d-flex justify-content-center">
        {props.cancel}
        <Button
          variant="contained"
          onClick={onSave}
          disabled={submit}
          id="btn-save"
        >
          {addLoading ? "Wait" : "Save"} &#x2713;
        </Button>
      </div>
      {/* )} */}
      {/* <div className="d-flex justify-content-center">
          {props.cancel}
          <Button
            variant="contained"
            onClick={onSave}
            disabled={submit}
            id="btn-save"
          >
            {updateLoading ? "Wait" : "Update"} &#x2713;
          </Button>
        </div> */}
    </>
  );
}

export default React.memo(StageDetails);
